import PropTypes from "prop-types";

function PlayIcon(props) {
    const { className, size = 24, color = "currentColor" } = props;

    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
            <path fillRule="evenodd" clipRule="evenodd" d="M7 6.33041C6.99994 6.15088 7.04822 5.97463 7.13976 5.82019C7.2313 5.66574 7.36274 5.53879 7.52027 5.45266C7.6778 5.36653 7.85561 5.3244 8.03504 5.33069C8.21447 5.33698 8.38889 5.39146 8.54 5.48841L17.358 11.1574C17.4988 11.248 17.6146 11.3724 17.6948 11.5194C17.7749 11.6663 17.817 11.831 17.817 11.9984C17.817 12.1658 17.7749 12.3305 17.6948 12.4775C17.6146 12.6244 17.4988 12.7488 17.358 12.8394L8.541 18.5084C8.39002 18.6055 8.21567 18.6602 8.03627 18.6667C7.85686 18.6732 7.67901 18.6313 7.52139 18.5454C7.36376 18.4595 7.23217 18.3327 7.14043 18.1784C7.04869 18.0241 7.00018 17.8479 7 17.6684V6.33041Z" fill={color} />
        </svg>
    );
}

export default PlayIcon;

PlayIcon.propTypes = {
    className: PropTypes.string,
    size: PropTypes.number,
    color: PropTypes.string,
}